import actions from './constants';

export const addDatasetNamespace = (category, code, name, namespace) => ({
  category,
  code,
  name,
  namespace,
  type: actions.ADD_DATASET_NAMESPACE,
});

export const addDatasetNamespaceSuccess = (category, code, name, namespace) => ({
  category,
  code,
  name,
  namespace,
  type: actions.ADD_DATASET_NAMESPACE_SUCCESS,
});

export const removeDatasetNamespaceSuccess = (category, code, name, namespace) => ({
  category,
  code,
  name,
  namespace,
  type: actions.REMOVE_DATASET_NAMESPACE_SUCCESS,
});

export const updateDatasetNamespacesError = (category, code, name, error) => ({
  category,
  code,
  error,
  name,
  type: actions.UPDATE_DATASET_NAMESPACES_ERROR,
});

export const removeDatasetNamespace = (category, code, name, namespace) => ({
  category,
  code,
  name,
  namespace,
  type: actions.REMOVE_DATASET_NAMESPACE,
});

export const fetchDatasetNamespaces = (category, code) => ({
  category,
  code,
  type: actions.FETCH_DATASET_NAMESPACES,
});

export const fetchDatasetNamespacesSuccess = (category, code, result) => (
  {
    category,
    code,
    result,
    type: actions.FETCH_DATASET_NAMESPACES_SUCCESS,
  });

export const fetchDatasetNamespacesError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.FETCH_DATASET_NAMESPACES_ERROR,
});
